import { render, staticRenderFns } from "./qModal.vue?vue&type=template&id=5bdc2172&"
import script from "./qModal.vue?vue&type=script&lang=ts&"
export * from "./qModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports